export default __webpack_public_path__ + "static/gengar-60ec782319b7bbd5101fe23e83e89fad.png";